// extracted by mini-css-extract-plugin
export var Footer = "index-module--Footer--ffc07";
export var Gutters = "index-module--Gutters--1d987";